import { Pipe, PipeTransform } from '@angular/core';
import { MessageType } from 'common/store/genesys-cloud/conversations/common/models/message-type.enum';

@Pipe({
  name: 'appChatPeriodEndedText'
})
export class ChatPeriodEndedTextPipe implements PipeTransform {

  transform(messageType: MessageType): string {
    switch (messageType) {
      case MessageType.WhatsApp:
        return 'gcChatMessageList.whatsAppChatPeriodEnded';
      case MessageType.Facebook:
        return 'gcChatMessageList.facebookChatPeriodEnded';
      default:
        return 'gcChatMessageList.openChatPeriodEnded';
    }
  }

}
